// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item[data-v-d39500b0]{box-sizing:border-box;border-left:3px solid transparent}.v-list-item.item-active[data-v-d39500b0]{border-left:3px solid var(--v-primary-base)}", ""]);
// Exports
module.exports = exports;
